module.exports = __webpack_public_path__ + "static/img/mask.3e63900.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mask.png
// module id = gmzI
// module chunks = 21